import { string } from 'prop-types';

import './index.scss'

const FormError = ({ message }) => {

    return (
        <div className="invalid-feedback d-block form-error">{message}</div>
    )
}

FormError.propTypes = {
    message: string
};

FormError.defaultProps = {
    message: null
};

export default FormError
